<template>
  <el-dialog
    :title="'付款记录'"
    class="flow-dialog"
    :visible.sync="visible"
    @close="handleClose"
    width="60%"
  >
    <div class="content-main-box content-main-box2">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="8">
            <div class="search-area-div w80">付款日期</div>
            <el-date-picker
              v-model="searchParams.payDate"
              type="daterange"
              class="ipt-sty"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="8">
            <div class="search-area-div w120">支付方开户银行</div>
            <el-input
              v-model="searchParams.payBankName"
              placeholder="请输入支付方开户银行"
              size="mini"
              class="ipt-sty"
            >
            </el-input>
          </el-col>
          <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="info" @click="searchRefundList"
              >搜索</el-button
            >
            <el-button size="mini" type="danger" @click="emptySearch"
              >清空</el-button
            >
          </el-col>
        </el-row>
      </div>

      <el-table
        :header-cell-class-name="cellClass"
        stripe
        border
        ref="multipleTable"
        highlight-current-row
        height="380px"
        :data="refundList"
        :row-key="(row) => row.guid"
        @row-click="handleRowClick"
        @select="handleSelect"
      >
        <el-table-column type="selection" :reserve-selection="true">
        </el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          width="160"
          prop="payDate"
          label="付款日期"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.receiveDate | getDate }}
          </template>
        </el-table-column>
        <el-table-column
          prop="receiveAmount"
          width="120"
          label="应付金额(元)"
          header-align="center"
          align="right"
        >
          <template slot-scope="scope">
            {{ scope.row.receiveAmount | numFmt | numDigit }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payBankName"
          width="200"
          label="支付方开户银行"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.payBankName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="payBankAccount"
          label="收款方"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.payBankAccount || "-" }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100, 200]"
        :current-page="searchParams.pageIndex"
        :page-size="searchParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchParams.totalRows"
      >
      </el-pagination>
    </div>

    <div slot="footer">
      <el-button plain size="mini" @click="visible = false">取消</el-button>
      <el-button size="mini" type="info" @click="confirmSelection"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { OrderTypeEnum } from "../enum";
export default {
  name: "PaymentRecordsDialog",
  props: {
    orderType: {
      type: String,
      default: OrderTypeEnum.SETTLEMENT,
    },
    refundDetail: {
      type: Array,
      default: [],
    },
    currentRowRelevance: {
      type: Object,
      default: () => ({}),
    },
    detailData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      refundList: [],
      searchParams: {
        payDate: "",
        payBankName: "",
        pageIndex: 1,
        pageSize: 50,
        totalRows: 0,
        totalPage: 0,
      },
      selectedRows: [],
    };
  },
  methods: {
    open() {
      this.visible = true;
      this.getRefundList();
      this.selectedRows = [...(this.refundDetail || [])];
      this.$refs.multipleTable?.clearSelection();
    },
    searchRefundList() {
      this.searchParams = {
        ...this.searchParams,
        pageIndex: 1,
        pageSize: 50,
      };
      this.getRefundList();
    },
    async getRefundList() {
      const params = {
        ...this.searchParams,
        isAllBack: "Y",
        receiveDateStart: this.searchParams.payDate[0] || "",
        receiveDateEnd: this.searchParams.payDate[1] || "",
        streamType: "2",
        payTenantGuid: this.currentRowRelevance.serviceTenantGuid || "",
        receiveTenantGuid: this.currentRowRelevance.tenantGuid || "",
        approveFlowNo: "",
        approveFlowNoList: [],
      };
      if (this.orderType == OrderTypeEnum.PAYMENT) {
        // 是付款单 查询条件
        params.approveFlowNo = this.detailData?.approveVO?.flowNo || "";
      }
      if (this.orderType == OrderTypeEnum.RECONCILIATION) {
        // 是对账单 查询条件
        params.approveFlowNoList = this.detailData?.flowNoList || [];
      }

      if (
        this.orderType == OrderTypeEnum.RECONCILIATION &&
        !params.approveFlowNoList.length
      ) {
        // 对账单的时候 如果没有关联账单 不查询 直接给空list
        this.refundList = [];
        return;
      }
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/invoiceItem/page-list`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.refundList = data.data.records || [];
      this.searchParams = {
        ...this.searchParams,
        totalRows: data.data.totalRows || 0,
        pageIndex: data.data.pageIndex || 1,
        pageSize: data.data.pageSize || 50,
        totalPage: data.data.totalPages || 0,
      };

      this.$nextTick(() => {
        this.selectedRows.forEach((selectedRow) => {
          const rowToSelect = this.refundList.find(
            (row) => row.guid === selectedRow.guid
          );
          if (rowToSelect) {
            this.$refs.multipleTable.toggleRowSelection(rowToSelect, true);
          }
        });
      });
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getRefundList();
    },
    handleCurrentChange(val) {
      this.searchParams.pageIndex = val;
      this.getRefundList();
    },
    emptySearch() {
      this.searchParams = {
        pageIndex: 1,
        pageSize: 50,
        payDate: "",
        payBankName: "",
      };
      this.getRefundList();
    },
    handleRowClick(row) {
      row.flag = !row.flag;
      // 勾选
      if (row.flag) {
        this.selectedRows.push(row);
      } else {
        // 取消勾选
        this.selectedRows = this.selectedRows.filter(
          (item) => item.guid !== row.guid
        );
      }
      this.$refs.multipleTable.toggleRowSelection(row, row.flag);
    },
    handleSelect(selection) {
      this.selectedRows = selection;
    },
    confirmSelection() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.error("请选择付款记录");
      }
      this.visible = false;
      this.$emit("select", this.selectedRows);
    },
    handleClose() {
      this.visible = false;
    },
    cellClass(row) {
      if (row.columnIndex === 0) {
        return "disabledCheck";
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
